import React, { useEffect, useState, useRef } from "react";
import SellSystemLeads from "./sellSystemLeads.js";
import SellSystemCalendar from "./sellSystemCalendar.js";
import { secretKey, monthData } from "../.././data";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Loading from "../helpers/loading_component.js";
import Select from "react-select";
import LoadingPopup from "../helpers/loading_component.js";

const MySwal = withReactContent(Swal2);

const AddSellSystemLead = (props) => {
  const [loading, setLoading] = useState(true);
  const [leadSource, setLeadSource] = useState([]);
  const [banks, setBanks] = useState([]);
  const [banksOptions, setBanksOptions] = useState([]);
  const [agreement, setAgreement] = useState([]);
  const [leadName, setLeadName] = useState("");
  const [leadPhone, setLeadPhone] = useState("");
  const [leadMail, setLeadMail] = useState("");
  const [leadSourceIn, setLeadSourceIn] = useState("");
  const [leadBankIn, setLeadBankIn] = useState("");
  const [leadCreditAmmount, setLeadCreditAmmount] = useState(0);
  const [leadCreditCurrency, setLeadCreditCurrency] = useState("");
  const [leadCreditDate, setLeadCreditDate] = useState("2008-08-01");
  const [leadCreditAgreement, setLeadCreditAgreement] = useState("");
  const [leadType, setLeadType] = useState("CHF");
  const [length, setLength] = useState("");
  const [end, setEnd] = useState("");
  const [note, setNote] = useState("");
  const [uploadFiles, setUploadFiles] = useState("");
  const [uploadFilesArray, setUploadFilesArray] = useState([]);
  const [uploadFilesNamesArray, setUploadFilesNamesArray] = useState([]);
  const [uploadFilesNamesArrayChanged, setUploadFilesNamesArrayChanged] =
    useState([]);
  const [inputs, setInputs] = useState({});
  const [fileType, setFileType] = useState("sell");
  const [changeDate, setChangeDate] = useState("");

  const changeFiles = (e) => {
    setUploadFiles([]);
    setUploadFilesArray([]);
    setUploadFilesNamesArray([]);

    var check = false;

    Array.from(e.target.files).map((file) => {
      if (file.size > 41943040) {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "plik przekracza 40MB",
        });
        check = true;
      }
    });

    if (check) {
      return;
    }

    setUploadFiles(e.target.files);
    setUploadFilesArray(Array.from(e.target.files));
    var arr = [];
    Array.from(e.target.files).map((el, index) => {
      arr.push({ id: index, name: el.name });
    });
    setUploadFilesNamesArray(arr);
  };

  const changeFileName = (e) => {
    if (inputs[e.target.value] === "" || inputs[e.target.value] === undefined) {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    } else {
      var name = inputs[e.target.value];
      var newFile = new File(
        [uploadFilesArray[e.target.value]],
        name + "." + uploadFilesArray[e.target.value].name.split(".")[1],
        {
          type: uploadFilesArray[e.target.value].type,
        }
      );

      var arr = uploadFilesArray.filter(
        (el, index) => index !== +e.target.value
      );
      arr.push(newFile);

      setUploadFilesArray(arr);
      inputs[e.target.value] = "";
    }
  };

  const deleteTempFile = (e) => {
    var arr = uploadFilesArray.filter((el, index) => index !== +e.target.value);

    setUploadFilesArray(arr);
  };

  const fetchLeadSource = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLeadSource", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLeadSource(data);
        fetchBanks();
      })
      .catch((error) => {});
  };

  const fetchBanks = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getBanks", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setBanks(data);
        setBanksOptions(createBankOptions(data));
        fetchSellAgreement();
      })
      .catch((error) => {});
  };

  const fetchSellAgreement = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getSellAgreement", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setAgreement(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchLeadSource();
  };

  useEffect(() => {
    getData();
  }, []);

  const checkDigit = (e) => {
    if (!/^\d*\,?\d*$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const validateLead = () => {
    if (leadName && leadPhone && leadMail && leadSourceIn) {
      return true;
    } else {
      return false;
    }
  };

  const addLead = async () => {
    if (changeDate === "") {
      MySwal.fire({
        icon: "error",
        title: "Uzupełnij",
        text: "datę wypłaty kredytu",
      }).then(() => {
        return;
      });
    } else if (validateLead()) {
      setLoading(true);

      var body = {
        name: leadName,
        phone: leadPhone,
        mail: leadMail,
        source: leadSourceIn,
        bank: leadBankIn,
        agreement: leadCreditAgreement,
        creditAmmount: leadCreditAmmount,
        creditCurrency: leadCreditCurrency,
        creditDate: leadCreditDate,
        addUser: props.user.name,
        type: leadType,
        end: end,
        length: length,
        note: note.replaceAll("'", "").replaceAll('"', ""),
        manual: "1",
      };

      await fetch("https://apidevkppp.ftpeople.pl/addLead", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then(async (data) => {
          var id = data.insertId;
          if (uploadFilesArray.length > 0) {
            var length = uploadFilesArray.length;
            var progr = 0;
            if (length > 0) {
              uploadFilesArray.map(async (file) => {
                let formData = new FormData();
                formData.append("file", file);
                formData.append("type", "sell");
                formData.append("leadId", id);
                formData.append("user", props.user.name);

                await fetch("https://apidevkppp.ftpeople.pl/uploadSellFile", {
                  method: "POST",
                  body: formData,
                })
                  .then((response) => {
                    return response.text();
                  })
                  .then((responseJson) => {
                    ++progr;
                    MySwal.fire({
                      icon: "success",
                      title: "Wysłano plik: " + progr + "/" + length,
                      text: "",
                    }).then(async (result) => {
                      if (progr === length) {
                        MySwal.fire({
                          icon: "success",
                          title: "Dodano",
                          text: "lead",
                        }).then(() => {
                          props.close();
                        });
                      }
                    });
                  });
              });
            } else {
              MySwal.fire({
                icon: "success",
                title: "Dodano",
                text: "lead",
              }).then(() => {
                props.close();
              });
            }
          } else {
            MySwal.fire({
              icon: "success",
              title: "Dodano",
              text: "lead",
            }).then(() => {
              props.close();
            });
          }
        })
        .catch((error) => {});
    } else {
      MySwal.fire({
        icon: "error",
        title: "Uzupełnij",
        text: "wymagane pola formularza",
      }).then(() => {});
    }
  };

  const addLeadUser = async () => {
    if (changeDate === "") {
      MySwal.fire({
        icon: "error",
        title: "Uzupełnij",
        text: "datę wypłaty kredytu",
      }).then(() => {
        return;
      });
    } else if (validateLead()) {
      setLoading(true);

      var body = {
        name: leadName,
        phone: leadPhone,
        mail: leadMail,
        source: leadSourceIn,
        bank: leadBankIn,
        agreement: leadCreditAgreement,
        creditAmmount: leadCreditAmmount,
        creditCurrency: leadCreditCurrency,
        creditDate: leadCreditDate,
        addUser: props.user.name,
        type: leadType,
        end: end,
        length: length,
        note: note,
        owner: props.user.name,
      };

      await fetch("https://apidevkppp.ftpeople.pl/addLeadUser2", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then(async (data) => {
          var id = data.insertId;
          if (uploadFilesArray.length > 0) {
            var length = uploadFilesArray.length;
            var progr = 0;
            if (length > 0) {
              uploadFilesArray.map(async (file) => {
                let formData = new FormData();
                formData.append("file", file);
                formData.append("type", "sell");
                formData.append("leadId", id);
                formData.append("user", props.user.name);

                await fetch("https://apidevkppp.ftpeople.pl/uploadSellFile", {
                  method: "POST",
                  body: formData,
                })
                  .then((response) => {
                    return response.text();
                  })
                  .then((responseJson) => {
                    ++progr;
                    MySwal.fire({
                      icon: "success",
                      title: "Wysłano plik: " + progr + "/" + length,
                      text: "",
                    }).then(async (result) => {
                      if (progr === length) {
                        MySwal.fire({
                          icon: "success",
                          title: "Dodano",
                          text: "lead",
                        }).then(() => {
                          props.close();
                        });
                      }
                    });
                  });
              });
            } else {
              MySwal.fire({
                icon: "success",
                title: "Dodano",
                text: "lead",
              }).then(() => {
                props.close();
              });
            }
          } else {
            MySwal.fire({
              icon: "success",
              title: "Dodano",
              text: "lead",
            }).then(() => {
              props.close();
            });
          }
        })
        .catch((error) => {});
    } else {
      MySwal.fire({
        icon: "error",
        title: "Uzupełnij",
        text: "wymagane pola formularza",
      }).then(() => {});
    }
  };

  const getBanksForTeam = (data) => {
    var usersForTeam = [];

    data.map((el) => {
      if (el.team.split(",").filter((el2) => +el2 === 1).length > 0) {
        usersForTeam.push(el);
      }
    });

    return usersForTeam;
  };

  const createBankOptions = (data) => {
    var banksOptions = [];
    getBanksForTeam(data).map((el) => {
      banksOptions.push({ label: el.name, value: el.name });
    });
    return banksOptions;
  };

  const changeCreditDate = (e) => {
    setLeadCreditDate(e.target.value);
    setChangeDate("1");
  };

  return (
    <>
      <div className="mainContainerAddClient">
        <div
          style={{ width: "100%", marginBottom: "1vh" }}
          className="closeBox"
        >
          <button className="closeClientButton" onClick={props.close}>
            X
          </button>
        </div>
        {loading ? (
          <>
            <LoadingPopup />
          </>
        ) : (
          <>
            <div className="inputBox">
              <div
                style={{ width: "49%", minWidth: "49%" }}
                className="inputCol_2"
              >
                <label>
                  Imię i nazwisko <span className="requiredStar">*</span>
                </label>
                <input
                  style={{ boxSizing: "border-box" }}
                  type="text"
                  id="name"
                  name="name"
                  value={leadName}
                  onChange={(e) => {
                    setLeadName(e.target.value);
                  }}
                />
              </div>

              <div
                style={{ width: "49%", minWidth: "49%" }}
                className="inputCol_2"
              >
                <label>
                  Numer telefonu <span className="requiredStar">*</span>
                </label>
                <input
                  style={{ boxSizing: "border-box" }}
                  type="text"
                  id="name"
                  name="name"
                  value={leadPhone}
                  onChange={(e) => {
                    setLeadPhone(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="inputBox">
              <div
                style={{ width: "49%", minWidth: "49%" }}
                className="inputCol_2"
              >
                <label>
                  Adres e-mail <span className="requiredStar">*</span>
                </label>
                <input
                  style={{ boxSizing: "border-box" }}
                  type="text"
                  id="name"
                  name="name"
                  value={leadMail}
                  onChange={(e) => {
                    setLeadMail(e.target.value);
                  }}
                />
              </div>

              <div
                style={{ width: "49%", minWidth: "49%" }}
                className="inputCol_2"
              >
                <label>
                  Źródło <span className="requiredStar">*</span>
                </label>
                <select
                  style={{ boxSizing: "border-box" }}
                  type="text"
                  id="name"
                  name="name"
                  value={leadSourceIn}
                  onChange={(e) => {
                    setLeadSourceIn(e.target.value);
                  }}
                >
                  {!leadSourceIn ? (
                    <>
                      <option key={9999} value={0}>
                        Wybierz...
                      </option>
                    </>
                  ) : (
                    ""
                  )}
                  {leadSource.map((el) => (
                    <>
                      <option key={el.id} value={el.name}>
                        {el.name}
                      </option>
                    </>
                  ))}
                </select>
              </div>
            </div>
            <div className="inputBox">
              <div
                style={{ width: "49%", minWidth: "49%" }}
                className="inputCol_2"
              >
                <label>
                  Rodzaj sprawy <span className="requiredStar">*</span>
                </label>
                <select
                  style={{ boxSizing: "border-box" }}
                  type="text"
                  id="name"
                  name="name"
                  value={leadType}
                  onChange={(e) => {
                    setLeadType(e.target.value);
                  }}
                >
                  {!leadType ? (
                    <>
                      <option key={0} value={0}>
                        Wybierz...
                      </option>
                    </>
                  ) : (
                    ""
                  )}
                  <>
                    <option key={1} value="CHF">
                      CHF
                    </option>
                    <option key={2} value="EURO">
                      EURO
                    </option>
                    <option key={3} value="USD">
                      USD
                    </option>
                    <option key={4} value="SKD">
                      SKD
                    </option>
                    <option key={5} value="WIBOR">
                      WIBOR
                    </option>
                  </>
                </select>
              </div>
              <div
                style={{ width: "49%", minWidth: "49%" }}
                className="inputCol_2"
              ></div>
            </div>
            <div className="inputBox">
              <div className="inputCol_1">
                <label>Bank</label>
                <Select
                  noOptionsMessage={() => "Brak danych"}
                  placeholder={"Wybierz..."}
                  isClearable={false}
                  value={
                    leadBankIn === ""
                      ? { label: "Wybierz...", value: "" }
                      : { label: leadBankIn, value: leadBankIn }
                  }
                  options={banksOptions}
                  onChange={(e) => {
                    setLeadBankIn(e.value);
                  }}
                />
              </div>
            </div>
            <div className="inputBox">
              <div className="inputCol_1">
                <label>Umowa kredytowa</label>
                <select
                  style={{ boxSizing: "border-box" }}
                  type="text"
                  id="name"
                  name="name"
                  value={leadCreditAgreement}
                  onChange={(e) => {
                    setLeadCreditAgreement(e.target.value);
                  }}
                >
                  {!leadCreditAgreement ? (
                    <>
                      <option key={0} value={0}>
                        Wybierz...
                      </option>
                    </>
                  ) : (
                    ""
                  )}
                  {agreement.map((el) => (
                    <>
                      <option key={el.id} value={el.agreement}>
                        {el.agreement}
                      </option>
                    </>
                  ))}
                </select>
              </div>
            </div>
            <div className="inputBox">
              <div
                style={{ width: "49%", minWidth: "49%" }}
                className="inputCol_2"
              >
                <label>Kwota kredytu</label>
                <input
                  style={{ boxSizing: "border-box" }}
                  type="number"
                  id="name"
                  name="name"
                  value={leadCreditAmmount}
                  onChange={(e) => {
                    setLeadCreditAmmount(e.target.value);
                  }}
                  onKeyPress={checkDigit}
                />
              </div>

              <div
                style={{ width: "49%", minWidth: "49%" }}
                className="inputCol_2"
              >
                <label>Waluta kredytu</label>
                <select
                  style={{ boxSizing: "border-box" }}
                  type="text"
                  id="name"
                  name="name"
                  value={leadCreditCurrency}
                  onChange={(e) => {
                    setLeadCreditCurrency(e.target.value);
                  }}
                >
                  {!leadCreditCurrency ? (
                    <>
                      <option key={0} value={0}>
                        Wybierz...
                      </option>
                    </>
                  ) : (
                    ""
                  )}
                  <option key={1} value={"PLN"}>
                    PLN
                  </option>
                  <option key={2} value={"CHF"}>
                    CHF
                  </option>
                  <option key={3} value={"EUR"}>
                    EUR
                  </option>
                  <option key={4} value={"USD"}>
                    USD
                  </option>
                </select>
              </div>
            </div>
            <div className="inputBox">
              <div
                style={{ width: "49%", minWidth: "49%" }}
                className="inputCol_2"
              >
                <label>Data kredytu</label>
                <input
                  style={{ boxSizing: "border-box" }}
                  type="date"
                  id="name"
                  name="name"
                  value={leadCreditDate}
                  onChange={changeCreditDate}
                />
              </div>
              <div
                style={{ width: "49%", minWidth: "49%" }}
                className="inputCol_2"
              >
                <label>Długość kredytu (w miesiącach)</label>
                <input
                  style={{ boxSizing: "border-box" }}
                  type="number"
                  id="name"
                  name="name"
                  value={length}
                  onChange={(e) => {
                    setLength(e.target.value);
                  }}
                  onKeyPress={checkDigit}
                />
              </div>
            </div>
            <div className="inputBox">
              <div
                style={{ width: "49%", minWidth: "49%" }}
                className="inputCol_2"
              >
                <label>Data zakończenia kredytu</label>
                <input
                  style={{ boxSizing: "border-box" }}
                  type="date"
                  id="name"
                  name="name"
                  value={end}
                  onChange={(e) => {
                    setEnd(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="inputBox">
              <div className="inputCol_1">
                <label>Notatka</label>
                <textarea
                  spellCheck="false"
                  className="textAreaNote"
                  type="text"
                  id="url"
                  name="url"
                  value={note}
                  onChange={(e) => {
                    setNote(e.target.value);
                  }}
                />
              </div>
            </div>
            <div
              className="inputBox"
              style={{
                display: "block",
                marginTop: "10vh",
                marginBottom: "10vh",
              }}
            >
              <input multiple={true} type="file" onChange={changeFiles} />
              <>
                <div
                  style={{ marginTop: "0", marginBottom: "5vh" }}
                  className="inputBox"
                ></div>
              </>
              <>
                {uploadFilesArray.length > 0 ? (
                  <>
                    <div style={{ maxHeight: "35vh", overflowY: "scroll" }}>
                      <table
                        style={{ width: "100%", boxSizing: "border-box" }}
                        id="detailClientTable"
                        className="clients_table"
                      >
                        <tr>
                          <th>Nazwa pliku</th>
                          <th>Plik</th>
                          <th></th>
                        </tr>
                        {uploadFilesArray.length > 0
                          ? uploadFilesArray.map((el, index) => (
                              <>
                                <tr>
                                  <td
                                    style={{
                                      width: "50%",
                                      padding: "5px 20px",
                                      height: "3vh",
                                    }}
                                  >
                                    <div
                                      style={{ display: "flex", gap: "10px" }}
                                    >
                                      <input
                                        id={"fn" + index}
                                        name={"fn" + index}
                                        style={{
                                          height: "2vh",
                                          marginTop: "0",
                                        }}
                                        type="text"
                                        value={inputs[index]}
                                        onChange={(e) =>
                                          setInputs((prev) => {
                                            return {
                                              ...prev,
                                              [index]: e.target.value,
                                            };
                                          })
                                        }
                                      />
                                      <button
                                        className="refreshButton"
                                        value={index}
                                        onClick={changeFileName}
                                      >
                                        zmień
                                      </button>
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      width: "40%",
                                      padding: "5px 20px",
                                      height: "3vh",
                                    }}
                                  >
                                    {el.name}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      width: "10%",
                                      padding: "5px 20px",
                                      height: "3vh",
                                    }}
                                  >
                                    <button
                                      className="refreshButton"
                                      value={index}
                                      onClick={deleteTempFile}
                                    >
                                      usuń
                                    </button>
                                  </td>
                                </tr>
                              </>
                            ))
                          : ""}
                      </table>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </>
            </div>
            <div className="inputBox" style={{ marginTop: "5vh" }}>
              <div
                style={{ width: "49%", minWidth: "49%" }}
                className="inputCol_2"
              >
                <button
                  style={{ backgroundColor: "white", width: "100%" }}
                  id="addButton"
                  className="acceptButton"
                  onClick={
                    props.user.adminSprzedaz === "1" ? addLead : addLeadUser
                  }
                >
                  DODAJ
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddSellSystemLead;
